import React, { useEffect, useState } from "react";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import Setting from "../../UI/Settings";
import SmmTicketProfile from "../../UI/SmmTicketProfile";
import SmmTicketCampaign from "../../UI/SmmTicketCampaign";

const SmmTicketCampaingPage = () => {
    const [data, setData] = useState();
    const [campaings, setCampaings] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const getData = async () => {
        const { response } = await Helper.Get({
            url: `${api_Routes.Smmticket.Campaigns}?per_page=${rowsPerPage}&page=${currentPage}`,
            hasToken: true,
        });
        if (response) {
            setCampaings(response);
        }
    };
    useEffect(() => {

        getData();
    }, []);
    return <SmmTicketCampaign
        data={data}
        campaings={campaings}
        getData={getData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
    />;
};

export default SmmTicketCampaingPage;
